import {searchPageSize} from '/constant/data.constant';
import {
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
} from '/enum/apiFields.enum';
import {SEARCH_COACH} from '/enum/request.enum';
import {request} from '/redux/api/request';
import {createPromisedAction} from '/util/action.util';
import {createStorage} from '/util/async-storage';
import {hasWhiteSpace} from '/util/text.util';

import {getErrorHandler} from './apiError.action';

export const GET_SEARCH_RESULTS: string = 'GET_SEARCH_RESULTS';
export const CANCEL_SEARCH: string = 'CANCEL_SEARCH';
export const UPDATE_SEARCH_INPUT: string = 'UPDATE_SEARCH_INPUT';
export const SET_IS_LOADING: string = 'SET_IS_LOADING';
export const GET_RECENT_SEARCHES: string = 'GET_RECENT_SEARCHES';
export const UPDATE_RECENT_SEARCHES: string = 'UPDATE_RECENT_SEARCHES';

const recentSearchesCount = 10;

export const {
  setValue: setRecentSearchesToStorage,
  getValue: getRecentSearchesFromStorage,
} = createStorage({key: 'recent-searches', defaultValue: []});

export const getSearchResults = createPromisedAction(
  GET_SEARCH_RESULTS,
  [
    'searchString',
    'searchOnlyInFrontlines',
    'searchOnlyInCoaches',
    'pageNumber',
    'appendData',
  ],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {
      searchInput,
      searchOnlyInFrontlines = false,
      searchOnlyInCoaches = false,
      pageNumber = 1,
      appendData = false,
      filterParam = 'default',
      filterByValue = '',
    } = inputPayload;

    // searchType as 2 means search by name, 1 - search by id
    let searchType = 2;
    if (Number.isInteger(parseFloat(searchInput))) {
      searchType = 1;
    }

    let isAutoFill = true;
    if (hasWhiteSpace(searchInput)) {
      isAutoFill = false;
    }

    return (
      Promise.resolve()
        .then(() =>
          dispatch(
            setIsLoading({
              searchInput,
              status: true,
              filterParam,
              filterByValue,
            }),
          ),
        )
        .then(() =>
          request(SEARCH_COACH, {
            body: {
              type: searchType,
              searchString: searchInput,
              isAutoFill,
              isFrontline: searchOnlyInFrontlines,
              isCoach: searchOnlyInCoaches,
              [PAGE_SIZE_FIELD_NAME]: searchPageSize,
              [PAGE_NUMBER_FIELD_NAME]: pageNumber,
            },
            getHeaders: ['search-count'],
          }),
        )
        // @ts-expect-error TS(2339): Property 'data' does not exist on type '{ data: nu... Remove this comment to see the full error message
        .then(({data, responseHeaders}) =>
          dispatchMe(() => {
            const total = responseHeaders[0];
            const countOfPages = Math.ceil(total / searchPageSize);
            const isEndReached = pageNumber >= countOfPages;

            return {
              searchInput,
              results: data,
              responseHeaders,
              filterParam,
              filterByValue,
              isEndReached,
              appendData,
            };
          }),
        )
        .then(() =>
          dispatch(
            setIsLoading({
              searchInput,
              status: false,
              filterParam,
              filterByValue,
            }),
          ),
        )
        .catch(
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          getErrorHandler(dispatch, {
            promisedAction: getSearchResults,
            params: inputPayload,
            sideAction: () =>
              dispatch(
                setIsLoading({
                  searchInput,
                  status: false,
                  filterParam,
                  filterByValue,
                }),
              ),
          }),
        )
    );
  },
);

export const updateSearchInput = createPromisedAction(UPDATE_SEARCH_INPUT, [
  'searchInput',
]);

export const cancelSearch = createPromisedAction(
  CANCEL_SEARCH,
  [],
  dispatchMe => {
    return dispatchMe();
  },
);

export const setIsLoading = createPromisedAction(SET_IS_LOADING, [
  'searchInput',
  'status',
  'filterParam',
  'filterByValue',
]);

export const getRecentSearches = createPromisedAction(
  GET_RECENT_SEARCHES,
  [],
  dispatchMe => {
    return getRecentSearchesFromStorage().then(recentSearches =>
      dispatchMe(() => ({recentSearches})),
    );
  },
);

export const saveToRecentSearches = createPromisedAction(
  UPDATE_RECENT_SEARCHES,
  ['item'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.

  async (dispatchMe: any, inputPayload: any) => {
    const {item} = inputPayload;
    let recentSearches = await getRecentSearchesFromStorage();
    recentSearches = recentSearches.filter(
      (value: any) => value.id !== item.id,
    );
    recentSearches.unshift(item);
    if (recentSearches.length > recentSearchesCount) {
      recentSearches.pop();
    }
    setRecentSearchesToStorage(recentSearches);
    return dispatchMe(() => ({
      recentSearches,
    }));
  },
);

export const deleteFromRecentSearches = createPromisedAction(
  UPDATE_RECENT_SEARCHES,
  ['item'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  async (dispatchMe: any, inputPayload: any) => {
    const {item} = inputPayload;
    let recentSearches = await getRecentSearchesFromStorage();
    recentSearches = recentSearches.filter(
      (value: any) => value.id !== item.id,
    );
    setRecentSearchesToStorage(recentSearches);
    dispatchMe(() => ({
      recentSearches,
    }));
  },
);

export const deleteAllRecentSearches = createPromisedAction(
  UPDATE_RECENT_SEARCHES,
  [],
  dispatchMe => {
    setRecentSearchesToStorage([]);
    dispatchMe(() => ({
      recentSearches: [],
    }));
  },
);
